<script setup>
import { PauseCircleIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "vue-i18n";
import NoticeScreen from "@/components/system/NoticeScreen.vue";

const { t } = useI18n();

const refresh = () => {
  window.location.reload();
};
</script>

<template>
  <NoticeScreen
    variant="sky"
    :status-icon="PauseCircleIcon"
    :status-label="t('pausedTimepoint.status')"
    :title="t('error.423.timepoint_paused.title')"
    :message="t('error.423.timepoint_paused.message')"
    :button-label="t('pausedTimepoint.refresh')"
    @action="refresh"
  />
</template>
